<template>
  <div class="head_calendar">

    <div class="arrows" @click='hisDateJump(false)' v-if="forward"><i class="iconfont icon-jiantou"></i></div>
    <div class="arrows" @click='weekJump(true,isToday)' v-else><i class="iconfont icon-jiantou"
                                                                  :class='{grey:isToday}'></i></div>
    <div class="calendar">

      <date-picker :date="defaultTime" :option='option' :limit="limit2" @change="selected" readonly="readonly"
                   @focus.prevent v-if="forward"></date-picker>
      <date-picker :date="defaultTime" :option='option' :limit="limit" @change="selected" readonly="readonly"
                   @focus.prevent v-else></date-picker>
    </div>

    <div class="arrows" @click='hisDateJump(true,isYesterday)' v-if="forward"><i class="iconfont icon-caret-right-copy"
                                                                                 :class='{grey:isYesterday}'></i></div>
    <div class="arrows" @click='weekJump(false)' v-else><i class="iconfont icon-caret-right-copy"></i></div>
  </div>
</template>

<script>
  import myDatepicker from 'vue-datepicker/vue-datepicker-es6'
  import moment from 'moment'
  import json from '../../conf/datePick.js'
  import {Toast} from 'mint-ui';

  export default {
    data() {
      return {
        startTime: {
          time: this.$route.query.date || moment().format("YYYY-MM-DD")
        },

        limit: [{
          type: 'fromto',
          from: moment().add('day', -1).format("YYYY-MM-DD"),
        }],

        limit2: [{
          type: 'fromto',
          to: moment().add('day', -1).format("YYYY-MM-DD"),
        }],
        option: json,


      }
    },
    props: {
      step: String,
      searchTime: {
        type: String,
        default: '',
      },
      forward: {
        type: Boolean,
        default: false,
      }
    },
    mounted() {
      if (this.searchTime) {
        this.startTime.time = this.searchTime;
      }
    },
    methods: {
      selected() {
        this.$emit('change', this.startTime.time)
      },
      weekJump(isBack, isToday) {
        if (isBack) {
          if (isToday) {
            Toast({
              message: this.$t('contrll_topDatePick_no_less_today'),
              position: 'center',
              duration: 1000
            });
            return;
          } else {
            var date = this.step ? moment(this.startTime.time).add(-this.step, 'd') : moment(this.startTime.time).add(-2, 'w');
            this.startTime.time = date.format('YYYY-MM-DD');
            if (moment(this.startTime.time).isBefore(moment())) {
              this.startTime.time = moment().format('YYYY-MM-DD')
            }
          }
        } else {
          var date = this.step ? moment(this.startTime.time).add(this.step, 'd') : moment(this.startTime.time).add(2, 'w');
          this.startTime.time = date.format('YYYY-MM-DD');
        }
        this.$emit('change', this.startTime.time)
      },
      hisDateJump(isForward, isYesterday) {
        if (isForward) {
          // console.log()
          if (isYesterday) {
            Toast({
              message: this.$t('contrll_no_big_yesterday'),
              position: 'center',
              duration: 1000
            });
            return;
          } else {
            var date = this.step ? moment(this.startTime.time).add(+this.step, 'd') : moment(this.startTime.time).add(2, 'w');
            console.log(moment(this.startTime.time).add(+this.step, 'd'))
            console.log(date)
            this.startTime.time = date.format('YYYY-MM-DD');
            if (moment().add('d', -1).isBefore(moment(this.startTime.time))) {
              this.startTime.time = moment().add('d', -1).format("YYYY-MM-DD");
            }
          }
        } else {
          var date = this.step ? moment(this.startTime.time).add(-this.step, 'd') : moment(this.startTime.time).add(-2, 'w');

          this.startTime.time = date.format('YYYY-MM-DD');
        }
        this.$emit('change', this.startTime.time)
      }
    },
    computed: {
      isToday() {
        return this.startTime.time == moment().format("YYYY-MM-DD")
      },
      isYesterday() {
        return this.startTime.time == moment().add('day', -1).format("YYYY-MM-DD")
      },
      defaultTime() {
        if (!!this.searchTime)
          this.startTime.time = this.searchTime;
        return this.startTime;
      }
    },
    components: {
      "date-picker": myDatepicker,
    }
  }
</script>

<style lang='less'>

  .grey {
    color: grey
  }


  .head_calendar {
    width: 4.4rem;
    height: 1.2rem;
    margin: 0 auto;

    .arrows {
      float: left;
      width: .4rem;
      text-align: center;

      .iconfont {
        line-height: 1.2rem;
      }
    }

    .calendar {
      width: 3.6rem;
      line-height: 1.2rem;
      float: left;
      text-align: center;
      font-size: .4rem;
    }
  }

  .cov-date-box {
    background: #fff;
  }

</style>



// WEBPACK FOOTER //
// topDatePick.vue?6428cc90